module.exports = __webpack_public_path__ + "img/login_a.9da8ede7.png";